<script>
import DatePicker from "vue2-datepicker"; // add DatePicker
import {
  required,
  minLength,
  maxLength,
  numeric,
  requiredIf,
} from "vuelidate/lib/validators";
import certificate from "../../../helpers/list/certificate";
import marital_status from "../../../helpers/list/marital_status";
import nationalism from "../../../helpers/list/nationalism";
import religion from "../../../helpers/list/religion";

export default {
  components: { DatePicker },
  props: {},

  data() {
    return {
      id_type: "1",

      name1: "",
      name2: "",
      name3: "",
      name4: "",
      family_name: "",
      mother_name: "",
      birth_date: "",
      phone1: "",
      phone2: "",
      national_id_number: "",
      nationality_number: "",
      marital_status_id: "",
      certificate_id: "",
      number_children: "",
      religion_id: "",
      nationalism_id: "",

      //lists
      list_certificate: certificate,
      list_marital_status: marital_status,
      list_nationalism: nationalism,
      list_religion: religion,
    };
  },

  validations: {
    id_type: { required },
    name1: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name2: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name3: { required, minLength: minLength(2), maxLength: maxLength(15) },
    name4: { required, minLength: minLength(2), maxLength: maxLength(15) },
    family_name: { required, minLength: minLength(2), maxLength: maxLength(15) },
    mother_name: { required, minLength: minLength(2), maxLength: maxLength(50) },
    birth_date: { required },
    phone1: { required, minLength: minLength(11), maxLength: maxLength(11) },
    phone2: { minLength: minLength(11), maxLength: maxLength(11) },
    number_children: {
      required,
      minLength: minLength(1),
      maxLength: maxLength(2),
    },
    religion_id: { required },
    nationalism_id: { required },
    marital_status_id: { required },
    certificate_id: { required },
    nationality_number: {
      required: requiredIf(function () {
        return this.getNationalityNumber();
      }),
      minLength: minLength(12),
      maxLength: maxLength(12),
    },
    national_id_number: {
      required: requiredIf(function () {
        return this.getNationalIdNumber();
      }),
      numeric,
      minLength: minLength(8),
      maxLength: maxLength(8),
    },
    form: [
      "id_type",
      "name1",
      "name2",
      "name3",
      "name4",
      "family_name",
      "mother_name",
      "birth_date",
      "phone1",
      "phone2",
      "national_id_number",
      "nationality_number",
      "marital_status_id",
      "certificate_id",
      "number_children",
      "religion_id",
      "nationalism_id",
    ],
  },
  methods: {
    getNationalityNumber() {
      return this.id_type == "1";
    },
    getNationalIdNumber() {
      return this.id_type == "2";
    },

    // validate
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid;
      this.$emit("on-validate", this.$data, isValid);
      return isValid;
    },
  },
  mounted() {},
};
</script>

<template>
  <!-- start page title -->
  <div>
    <!-- جريح -->
    <div class="row">
      <!-- modal info -->
      <div class="col-md-12">
        <div class="about-info">
          <i class="bx bx-left-arrow-circle bx-fade-left"></i>
          <a href="javascript: void(0);" v-b-modal.modal-info class="text-dark"
            >قراءة التعليمات</a
          >
        </div>
      </div>
      <b-modal
        id="modal-info"
        size="md"
        title="قراءة التعليمات"
        title-class="font-18"
        hide-footer
      >
        <h5 class="mb-2">
          تعليمات ملء استمارة اطفاء القروض الحكومية الخاصة بـ " الجرحى " .
        </h5>
        <ul class="li-info">
          <li>الدقة في ملء بيانات الاستمارة .</li>
          <li>يجب ان تكون نسبة العجز بالنسبة للجريح لا تقل عن 50% .</li>
          <li>
            عند رفع المرفقات في الحقول المخصصة للمرفقات يجب ان تكون بصيغة ( pdf. ) وبحجم
            لا يتجاوز ( 2mb ) .
          </li>
        </ul>
      </b-modal>
      <!-- title -->
      <hr class="hr-title" />
      <div class="break-title"><h5 class="mb-4">بيانات الجريح الشخصية</h5></div>
      <b-form-group class="col-md-3 mb-3" label="الاسم : " label-for="name1">
        <b-form-input
          id="name1"
          type="text"
          placeholder="ادخل الاسم"
          v-model="name1"
          :class="{ 'is-invalid': $v.name1.$error }"
        ></b-form-input>
        <div v-if="$v.name1.$error" class="invalid-feedback">
          <span v-if="!$v.name1.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name1.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name1.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الاب : " label-for="name2">
        <b-form-input
          id="name2"
          type="text"
          placeholder="ادخل اسم الاب"
          v-model="name2"
          :class="{ 'is-invalid': $v.name2.$error }"
        ></b-form-input>
        <div v-if="$v.name2.$error" class="invalid-feedback">
          <span v-if="!$v.name2.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name2.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name2.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم الجد : " label-for="name3">
        <b-form-input
          id="name3"
          type="text"
          placeholder="ادخل اسم الجد"
          v-model="name3"
          :class="{ 'is-invalid': $v.name3.$error }"
        ></b-form-input>
        <div v-if="$v.name3.$error" class="invalid-feedback">
          <span v-if="!$v.name3.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name3.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name3.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-3 mb-3" label="اسم اب الجد : " label-for="name4">
        <b-form-input
          id="name4"
          type="text"
          placeholder="ادخل اسم اب الجد"
          v-model="name4"
          :class="{ 'is-invalid': $v.name4.$error }"
        ></b-form-input>
        <div v-if="$v.name4.$error" class="invalid-feedback">
          <span v-if="!$v.name4.required">هذا الحقل الزامي</span>
          <span v-if="!$v.name4.minLength">يجب أن يتكون الاسم من حرفين على الأقل</span>
          <span v-if="!$v.name4.maxLength">يجب أن يتكون الاسم من 15 حرف على الاكثر</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-6 mb-3" label=" اللقب : " label-for="family_name">
        <b-form-input
          id="family_name"
          type="text"
          placeholder="ادخل اللقب"
          v-model="family_name"
          :class="{ 'is-invalid': $v.family_name.$error }"
        ></b-form-input>
        <div v-if="$v.family_name.$error" class="invalid-feedback">
          <span v-if="!$v.family_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.family_name.minLength"
            >يجب أن يتكون اللقب من حرفين على الأقل</span
          >
          <span v-if="!$v.family_name.maxLength"
            >يجب أن يتكون اللقب من 15 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-6 mb-3"
        label="اسم الام الثلاثي : "
        label-for="mother_name"
      >
        <b-form-input
          id="mother_name"
          type="text"
          placeholder="ادخل اسم الام الثلاثي"
          v-model="mother_name"
          :class="{ 'is-invalid': $v.mother_name.$error }"
        ></b-form-input>
        <div v-if="$v.mother_name.$error" class="invalid-feedback">
          <span v-if="!$v.mother_name.required">هذا الحقل الزامي</span>
          <span v-if="!$v.mother_name.minLength"
            >يجب أن يتكون اسم الام الثلاثي من حرفين على الأقل</span
          >
          <span v-if="!$v.mother_name.maxLength"
            >يجب أن يتكون اسم الام الثلاثي من 50 حرف على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-4 mb-3" label="تاريخ التولد : " label-for="birth_date">
        <date-picker
          id="birth_date"
          type="date"
          lang="ar"
          value-type="DD-MM-YYYY"
          format="DD-MM-YYYY"
          placeholder="اختر تاريخ التولد"
          v-model="birth_date"
          :class="{ 'is-invalid': $v.birth_date.$error }"
        ></date-picker>
        <div v-if="$v.birth_date.$error" class="invalid-feedback">
          <span v-if="!$v.birth_date.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label=" الحالة الاجتماعية : "
        label-for="marital_status_id"
      >
        <select
          class="form-control"
          id="marital_status_id"
          v-model="marital_status_id"
          :class="{ 'is-invalid': $v.marital_status_id.$error }"
        >
          <option value="">اختر الحالة الاجتماعية</option>
          <option
            v-for="marital_status in list_marital_status"
            :value="marital_status.id"
            :key="marital_status.id"
          >
            {{ marital_status.name }}
          </option>
        </select>
        <div v-if="$v.marital_status_id.$error" class="invalid-feedback">
          <span v-if="!$v.marital_status_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        class="col-md-4 mb-3"
        label=" عدد الابناء : "
        label-for="number_children"
      >
        <b-form-input
          id="number_children"
          type="number"
          placeholder="ادخل عدد الابناء "
          v-model="number_children"
          :class="{ 'is-invalid': $v.number_children.$error }"
        ></b-form-input>
        <div v-if="$v.number_children.$error" class="invalid-feedback">
          <span v-if="!$v.number_children.required">هذا الحقل الزامي</span>
          <span v-if="!$v.number_children.minLength"
            >يجب أن يتكون عدد الابناء من رقم واحد على الأقل</span
          >
          <span v-if="!$v.number_children.maxLength"
            >يجب أن يتكون عدد الابناء من رقمين على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group
        class="col-md-4 mb-3"
        label=" التحصيل الدراسي : "
        label-for="certificate_id"
      >
        <select
          class="form-control"
          id="certificate_id"
          v-model="certificate_id"
          :class="{ 'is-invalid': $v.certificate_id.$error }"
        >
          <option value="">اختر التحصيل الدراسي</option>
          <option
            v-for="certificate in list_certificate"
            :value="certificate.id"
            :key="certificate.id"
          >
            {{ certificate.name }}
          </option>
        </select>
        <div v-if="$v.certificate_id.$error" class="invalid-feedback">
          <span v-if="!$v.certificate_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" رقم الهاتف 1 : " label-for="phone1">
        <b-form-input
          id="phone1"
          type="number"
          placeholder="ادخل رقم الهاتف"
          v-model="phone1"
          :class="{ 'is-invalid': $v.phone1.$error }"
        ></b-form-input>
        <div v-if="$v.phone1.$error" class="invalid-feedback">
          <span v-if="!$v.phone1.required">هذا الحقل الزامي</span>
          <span v-if="!$v.phone1.minLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
          >
          <span v-if="!$v.phone1.maxLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group class="col-md-4 mb-3" label=" رقم الهاتف 2 : " label-for="phone2">
        <b-form-input
          id="phone2"
          type="number"
          placeholder="ادخل رقم الهاتف"
          v-model="phone2"
          :class="{ 'is-invalid': $v.phone2.$error }"
        ></b-form-input>
        <div v-if="$v.phone2.$error" class="invalid-feedback">
          <span v-if="!$v.phone2.minLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الأقل</span
          >
          <span v-if="!$v.phone2.maxLength"
            >يجب أن يتكون رقم الهاتف من 11 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-6 mb-3" label=" الديانة : " label-for="religion_id">
        <select
          class="form-control"
          id="religion_id"
          v-model="religion_id"
          :class="{ 'is-invalid': $v.religion_id.$error }"
        >
          <option value="">اختر الديانة</option>
          <option
            v-for="religion in list_religion"
            :value="religion.id"
            :key="religion.id"
          >
            {{ religion.name }}
          </option>
        </select>
        <div v-if="$v.religion_id.$error" class="invalid-feedback">
          <span v-if="!$v.religion_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group class="col-md-6 mb-3" label=" القومية : " label-for="nationalism_id">
        <select
          class="form-control"
          id="nationalism_id"
          v-model="nationalism_id"
          :class="{ 'is-invalid': $v.nationalism_id.$error }"
        >
          <option value="">اختر القومية</option>
          <option
            v-for="nationalism in list_nationalism"
            :value="nationalism.id"
            :key="nationalism.id"
          >
            {{ nationalism.name }}
          </option>
        </select>
        <div v-if="$v.nationalism_id.$error" class="invalid-feedback">
          <span v-if="!$v.nationalism_id.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
    </div>
    <div class="row">
      <b-form-group class="col-md-6 mb-3" label="اختر نوع البطاقة :" label-for="id_type">
        <select
          class="form-control"
          id="id_type"
          v-model="id_type"
          :class="{ 'is-invalid': $v.id_type.$error }"
        >
          <option value="">اختر البطاقة</option>
          <option value="1">بطاقة وطنية</option>
          <option value="2">هوية احوال مدنية</option>
        </select>
        <div v-if="$v.id_type.$error" class="invalid-feedback">
          <span v-if="!$v.id_type.required">هذا الحقل الزامي</span>
        </div>
      </b-form-group>
      <b-form-group
        v-if="getNationalityNumber()"
        class="col-md-6 mb-3"
        label="رقم البطاقة الوطنية :"
        label-for="nationality_number"
      >
        <b-form-input
          id="nationality_number"
          type="number"
          placeholder="ادخل رقم البطاقة الوطنية"
          v-model="nationality_number"
          :class="{ 'is-invalid': $v.nationality_number.$error }"
        ></b-form-input>
        <div v-if="$v.nationality_number.$error" class="invalid-feedback">
          <span v-if="!$v.nationality_number.required">هذا الحقل الزامي</span>
          <span v-if="!$v.nationality_number.minLength"
            >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الأقل</span
          >
          <span v-if="!$v.nationality_number.maxLength"
            >يجب أن يتكون رقم البطاقة الوطنية من 12 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
      <b-form-group
        v-if="getNationalIdNumber()"
        class="col-md-6 mb-3"
        label="رقم هوية الاحوال المدنية :"
        label-for="national_id_number"
      >
        <b-form-input
          id="national_id_number"
          type="text"
          placeholder="ادخل رقم هوية الاحوال المدنية"
          v-model="national_id_number"
          :class="{ 'is-invalid': $v.national_id_number.$error }"
        ></b-form-input>
        <div v-if="$v.national_id_number.$error" class="invalid-feedback">
          <span v-if="!$v.national_id_number.required">هذا الحقل الزامي</span>
          <span v-if="!$v.national_id_number.numeric"
            >يجب ان تكون قيمة هذا الحقل ارقاما فقط .
          </span>
          <span v-if="!$v.national_id_number.minLength"
            >يجب أن يتكون رقم هوية الاحوال المدنية من 8 رقم على الأقل</span
          >
          <span v-if="!$v.national_id_number.maxLength"
            >يجب أن يتكون رقم هوية الاحوال المدنية من 8 رقم على الاكثر</span
          >
        </div>
      </b-form-group>
    </div>
  </div>
  <!-- end page title -->
</template>
